import type { DRM } from '@setplex/tria-api'

import { useUnit } from 'effector-react'
import { useEffect, useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useSetFromComeLocation } from '~/shared/effector/previousLocation'
import { $modifiedUrl, setPlaybackParams } from '../model'

type IncomingPlaybackParams = {
  url: string | undefined
  drm: DRM | undefined | null
  contentId?: string | number
}

type PlaybackParams = {
  url: string | undefined
  drm: DRM | undefined
}

export function usePlaybackUrlAdParams(
  { url, drm, contentId }: IncomingPlaybackParams,
  el?: HTMLElement
): PlaybackParams {
  const setUrl = useUnit(setPlaybackParams)
  const modifiedUrl = useUnit($modifiedUrl)

  // sessionId using in google pal analytics
  // it must be constant when open the player and when navigating via player
  const sessionId = useMemo(() => uuidv4(), [])

  // update previous location, where user was prior to player
  useSetFromComeLocation()

  // get video height and width from player container
  const { offsetHeight: videoHeight, offsetWidth: videoWidth } = el || {}

  useEffect(() => {
    setUrl({ url: url ?? '', sessionId, videoHeight, videoWidth })
    return () => void setUrl({ url: '', sessionId, videoHeight, videoWidth })
  }, [url, contentId, sessionId, setUrl, videoHeight, videoWidth])

  const resultUrl = url && modifiedUrl ? modifiedUrl : undefined
  const resultDrm = resultUrl ? (drm ?? undefined) : undefined

  return { url: resultUrl, drm: resultDrm }
}
